import { createRoot, type Root } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@platform/state/store';
import type { IEntryNavigator } from './IEntryNavigator';
import { ObserverLayer } from './ObserverLayer';
import { authRoutes } from '../auth/authRoutes';

const LAYER_ID = 'po-observer-layer';
const ROOT_KEY = '__poObserverLayerRoot';

/**
 * Монтує шар спостерігача (банер і data-observer) в окремий корінь React поруч із застосунком — той самий store, отже та сама сесія й кеш
 * API; «Змінити особу» веде роутер на /observe. Повторний виклик (гаряче оновлення модуля роутера в розробці) замінює попередній корінь.
 */
export function mountObserverLayer(router: IEntryNavigator): void {
  const holder = window as unknown as Record<string, Root | undefined>;
  holder[ROOT_KEY]?.unmount();
  let el = document.getElementById(LAYER_ID);
  if (!el) {
    el = document.createElement('div');
    el.id = LAYER_ID;
    document.body.appendChild(el);
  }
  const root = createRoot(el);
  holder[ROOT_KEY] = root;
  root.render(
    <Provider store={store}>
      <ObserverLayer onSwitched={() => router.navigate(authRoutes.observe())} />
    </Provider>,
  );
}
